export default [{
  header: 'Expedientes',
  icon: '',
  i18n: 'Documentos',
  items: [
    {
      url: null,
      name: 'Bandejas',
      slug: 'InboxIcon',
      icon: 'FileIcon',
      permiso: 'ED009',
      submenu: [
        {
          url: { name: 'files', params: { view: 'generalSoporte' } },
          name: 'General - Soporte',
          icon: 'HardDriveIcon',
          permiso: 'FEB99',
          i18n: 'expedientes'
        }],
    },
    {
      url: null,
      name: 'Aprobaciones',
      slug: 'InboxIcon',
      icon: 'FileIcon',
      permiso: 'ED056',
      submenu: [
        {
          url: { name: 'approval-trays', params: { view: 'general' } },
          name: 'Bandeja General',
          icon: 'LayersIcon',
          permiso: 'FEB99'
        }
      ]
    },
    {
      url: null,
      name: 'Mantenedores',
      slug: 'settings',
      icon: 'FileIcon',
      permiso: 'ED004',
      submenu: [
        {
          url: { name: 'maintainer-files' },
          name: 'Documentos',
          icon: 'library_books',
          i18n: 'Documents',
          permiso: 'ED005'
        },
        {
          url: { name: 'maintainer-institutions' },
          name: 'Instituciones',
          icon: 'library_books',
          permiso: 'ED006',
          i18n: 'Instituciones'
        },
        {
          url: { name: 'maintainer-subjects' },
          name: 'Destinos',
          icon: 'library_books',
          permiso: 'ED007',
          i18n: 'Destinos'
        },
        {
          url: { name: 'maintainer-services' },
          name: 'Servicios',
          icon: 'library_books',
          permiso: 'ED110',
          i18n: 'Servicios'
        },
        {
          url: { name: 'maintainer-regions' },
          name: 'Regiones',
          icon: 'library_books',
          permiso: 'ED111',
          i18n: 'Regiones'
        },
        {
          url: { name: 'maintainer-activities' },
          name: 'Actividades',
          slug: '/herramientas/mantenedor-actividades',
          icon: 'library_books',
          permiso: 'ED048',
          i18n: 'Actividades'
        },
        {
          url: { name: 'maintainer-kanban-states' },
          name: 'Estados Kanban',
          slug: '/herramientas/mantenedor-estados-kanban',
          icon: 'library_books',
          permiso: 'ED059',
          i18n: 'States'
        }
      ]
    },
    {
      url: null,
      name: 'Correos',
      slug: 'InboxIcon',
      icon: 'InboxIcon',
      permiso: 'FEB99',
      submenu: [
        {
          url: { name: 'emails' },
          name: 'Enviados',
          icon: 'DollarSignIcon',
          permiso: 'FEB99',
          i18n: 'Sended'
        },
        {
          url: { name: 'emails/received' },
          name: 'Recibidos',
          icon: 'DownloadIcon',
          permiso: 'FEB99',
          i18n: 'Received'
        },
        {
          url: { name: 'emails/suppressed' },
          name: 'Suprimidos',
          icon: 'DollarSignIcon',
          permiso: 'FEB99',
          i18n: 'Suppressed'
        }
      ],
    }
  ]
}];
